import translate from '@translate';

/**
 * Mapping of URGENT field values to their translation keys
 */
const urgentValueMapping: { [key: string]: string } = {
    'OK': 'utils.receivingUrgentCodes.ok',
    'ok': 'utils.receivingUrgentCodes.ok',
    'Po Urgenci': 'utils.receivingUrgentCodes.afterUrgent',
    'Po urgenci': 'utils.receivingUrgentCodes.afterUrgent',
    'Vytvořeno Skladonem': 'utils.receivingUrgentCodes.createdBySkladon',
    'Nefakturovat': 'utils.receivingUrgentCodes.notInvoiced',
    // English variants (in case they come from API)
    'After urging': 'utils.receivingUrgentCodes.afterUrgent',
    'Created by Skladon': 'utils.receivingUrgentCodes.createdBySkladon',
    'Not invoiced': 'utils.receivingUrgentCodes.notInvoiced',
    // Additional variants that might exist
    'Přijato bez ASN': 'utils.receivingUrgentCodes.recievedWithoutAsn',
    'Received without ASN': 'utils.receivingUrgentCodes.recievedWithoutAsn',
};

/**
 * Translates URGENT field value to the appropriate language
 * @param value - The raw URGENT field value
 * @returns Translated value or original value if no translation found
 */
export const translateUrgentValue = (value: string | null | undefined): string => {
    if (!value) {
        return '';
    }

    // Try to find exact match first
    const translationKey = urgentValueMapping[value];
    if (translationKey) {
        return translate(translationKey);
    }

    // Try case-insensitive match
    const lowerValue = value.toLowerCase();
    const matchingKey = Object.keys(urgentValueMapping).find(
        key => key.toLowerCase() === lowerValue
    );
    
    if (matchingKey) {
        return translate(urgentValueMapping[matchingKey]);
    }

    // Return original value if no translation found
    return value;
};

export default translateUrgentValue;
